import GQL from '@core/gql/gql';

export default async function checkActivationGeo(gql: GQL): Promise<boolean> {
    try {
        const geo = await gql.geo();

        if (geo.countryCode === 'BG') {
            return true;
        }
    } catch {
        // failed checks also go to the geo-lock page
    }

    window.location.replace('/geo-lock');
    return false;
}
